var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEigenlayerPoints = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 14.6668C11.6819 14.6668 14.6667 11.682 14.6667 8.00015C14.6667 4.31826 11.6819 1.3335 8.00002 1.3335C4.31813 1.3335 1.33337 4.31826 1.33337 8.00015C1.33337 11.682 4.31813 14.6668 8.00002 14.6668Z",
    fill: "#1A0C6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75747 8.00043V4.81201H5.10156V8.00043V11.1888H10.0692V9.59461H8.41337V8.00043H10.0692V6.40622H9.23989V4.81201H7.61556V5.61049H8.41049V8.00043H7.5811V9.59461H6.75747V8.00043ZM10.0692 6.40622H10.8986V4.81201H10.0692V6.40622Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEigenlayerPoints);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_eigenlayer_points.ad5ac4c6ccc0839ad7bdb4840eed9b54.svg";